var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { GlobalCSS, keyframes } from "@classdojo/web/nessie/stylingLib";
import { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { Fragment as _Fragment } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
var BOUNCE_ENTER_TIME = 1300;
var BOUNCE_EXIT_TIME = 100;
var DELAY_TIME = 800;
var animationTimeout = {
  bounceAnimation: {
    delay: DELAY_TIME,
    enter: BOUNCE_ENTER_TIME,
    exit: BOUNCE_EXIT_TIME
  },
  slide: {
    delay: DELAY_TIME,
    enter: 300,
    exit: 300
  }
};
export var AnimationWrapper = function AnimationWrapper(_ref) {
  var type = _ref.type,
      animate = _ref.animate,
      children = _ref.children,
      isVisible = _ref.isVisible,
      delay = _ref.delay;

  var _useState = useState(animate ? false : isVisible),
      _useState2 = _slicedToArray(_useState, 2),
      startAnimation = _useState2[0],
      setStartAnimation = _useState2[1];

  var enter = animationTimeout[type].enter;
  var exit = animationTimeout[type].exit;
  var delayOverride = delay || animationTimeout[type].delay;
  useEffect(function () {
    if (animate && isVisible) {
      setTimeout(function () {
        if (animate && isVisible) {
          setStartAnimation(true);
        }
      }, delayOverride);
    }
  }, [animate, isVisible, delayOverride]);

  if (animate) {
    return _jsx(_Fragment, {
      children: _jsx(CSSTransition, {
        classNames: type,
        "in": startAnimation && isVisible,
        unmountOnExit: true,
        timeout: {
          enter: enter,
          exit: exit
        },
        children: children
      })
    });
  } else {
    return isVisible ? children : null;
  }
};
export var AnimationGlobalStyles = function AnimationGlobalStyles() {
  var popupBounce = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    0% { transform: matrix3d(0.5, 0, 0, 0, 0, 0.5, 0, 0, 0, 0, 1, 0, 0, 25, 0, 1); opacity: 0.5}\n    1.3% { transform: matrix3d(0.563, 0, 0, 0, 0, 0.563, 0, 0, 0, 0, 1, 0, 0, 20.348, 0, 1); opacity: 0.55}\n    2.6% { transform: matrix3d(0.646, 0, 0, 0, 0, 0.646, 0, 0, 0, 0, 1, 0, 0, 16.63, 0, 1); opacity: 0.6}\n    3.4% { transform: matrix3d(0.703, 0, 0, 0, 0, 0.703, 0, 0, 0, 0, 1, 0, 0, 14.569, 0, 1); opacity: 0.65}\n    5.16% { transform: matrix3d(0.833, 0, 0, 0, 0, 0.833, 0, 0, 0, 0, 1, 0, 0, 10.487, 0, 1); opacity: 0.7}\n    6.81% { transform: matrix3d(0.946, 0, 0, 0, 0, 0.946, 0, 0, 0, 0, 1, 0, 0, 7.222, 0, 1); opacity: 0.75}\n    7.76% { transform: matrix3d(1.004, 0, 0, 0, 0, 1.004, 0, 0, 0, 0, 1, 0, 0, 5.645, 0, 1); opacity: 0.8}\n    10.21% { transform: matrix3d(1.113, 0, 0, 0, 0, 1.113, 0, 0, 0, 0, 1, 0, 0, 2.645, 0, 1); opacity: 0.85}\n    10.31% { transform: matrix3d(1.116, 0, 0, 0, 0, 1.116, 0, 0, 0, 0, 1, 0, 0, 2.554, 0, 1); opacity: 0.9}\n    13.61% { transform: matrix3d(1.166, 0, 0, 0, 0, 1.166, 0, 0, 0, 0, 1, 0, 0, 0.6, 0, 1); opacity: 0.95}\n    15.47% { transform: matrix3d(1.154, 0, 0, 0, 0, 1.154, 0, 0, 0, 0, 1, 0, 0, 0.151, 0, 1); opacity: 1}\n    17.52% { transform: matrix3d(1.12, 0, 0, 0, 0, 1.12, 0, 0, 0, 0, 1, 0, 0, -0.063, 0, 1); opacity: 1}\n    20.62% { transform: matrix3d(1.05, 0, 0, 0, 0, 1.05, 0, 0, 0, 0, 1, 0, 0, -0.126, 0, 1); opacity: 1}\n    21.32% { transform: matrix3d(1.035, 0, 0, 0, 0, 1.035, 0, 0, 0, 0, 1, 0, 0, -0.122, 0, 1); opacity: 1}\n    25.23% { transform: matrix3d(0.969, 0, 0, 0, 0, 0.969, 0, 0, 0, 0, 1, 0, 0, -0.075, 0, 1); opacity: 1}\n    29.03% { transform: matrix3d(0.948, 0, 0, 0, 0, 0.948, 0, 0, 0, 0, 1, 0, 0, -0.037, 0, 1); opacity: 1}\n    36.74% { transform: matrix3d(0.989, 0, 0, 0, 0, 0.989, 0, 0, 0, 0, 1, 0, 0, -0.006, 0, 1); opacity: 1}\n    44.44% { transform: matrix3d(1.016, 0, 0, 0, 0, 1.016, 0, 0, 0, 0, 1, 0, 0, -0.001, 0, 1); opacity: 1}\n    50% { transform: matrix3d(1.008, 0, 0, 0, 0, 1.008, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); opacity: 1}\n    59.86% { transform: matrix3d(0.995, 0, 0, 0, 0, 0.995, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); opacity: 1}\n    75.28% { transform: matrix3d(1.002, 0, 0, 0, 0, 1.002, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); opacity: 1}\n    90.69% { transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); opacity: 1}\n    100% { transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); opacity: 1}\n  "])));
  return _jsx(GlobalCSS, {
    styles: {
      ".slide-enter": {
        transform: "translateX(calc(100%))"
      },
      ".slide-enter-active": {
        transform: "translateX(0)",
        transition: "transform 300ms",
        transitionTimingFunction: "cubic-bezier(0.7, -0.4, 0.4, 1.4)"
      },
      ".slide-exit": {
        transform: "translateX(0)"
      },
      ".slide-exit-active": {
        transform: "translateX(calc(100%))",
        transition: "transform 300ms",
        transitionTimingFunction: "cubic-bezier(0.7, -0.4, 0.4, 1.4)"
      },
      ".bounceAnimation-enter": {
        animation: "".concat(popupBounce, " ").concat(BOUNCE_ENTER_TIME, "ms linear both")
      },
      ".bounceAnimation-exit": {
        transition: "opacity ".concat(BOUNCE_EXIT_TIME, "ms ease-in-out"),
        WebkitTransition: "opacity ".concat(BOUNCE_EXIT_TIME, "ms ease-in-out"),
        opacity: 1
      },
      ".bounceAnimation-exit.bounceAnimation-exit-active": {
        opacity: 0
      }
    }
  });
};
//# sourceMappingURL=AnimationWrapper.js.map